// extracted by mini-css-extract-plugin
export default {"skipToMainContentLink":"SkipToMainComponent-module__skipToMainContentLink__3v3ej"};